import { proxy, snapshot } from 'valtio'

import { parsePhoneNumberFromString } from '../../util/phone-number'

interface PhoneNumber {
  number: string
  country: string
}

export interface PhoneNumberState {
  phone: PhoneNumber
}

const state = proxy<PhoneNumberState>({
  phone: {
    number: '',
    country: '',
  },
})

const setPhone = (phone: string) => {
  state.phone = parsePhoneNumberFromString(phone) as PhoneNumber
}

export const usePhoneState = () => {
  const snap = snapshot(state)

  return {
    phone: snap.phone,
    setPhone,
  }
}
